
import Vue from "vue";
import Component from "vue-class-component";

@Component({
  name: "SimpleBreadcrumbs",
  props: {
    location: {
      type: String,
      required: true,
    },
  },
})
export default class SimpleBreadcrumbs extends Vue {
  get mobileBreakpoint() {
    return this.$vuetify.breakpoint.smAndDown;
  }
}
